module.exports = __webpack_public_path__ + "media/unipod/installation_horizontal_2-66f69691.jpg";